import React from "react";
import Toast from "./Toast";
import { useToast } from "../../contexts/ToastContext";

/**
 * Bottom-center toast stack. Reads the live `toasts` array from `ToastContext`
 * and renders one presentational `Toast` per entry. Rendered once at the app
 * root (alongside `NotificationProvider`) so any page can fire toasts via the
 * `useToast` hook.
 *
 * The container itself is click-through (`pointer-events-none`); each toast
 * wrapper re-enables `pointer-events-auto` so only the × button (and toast
 * body) are interactive, not the empty stack space.
 *
 * z-index is `z-[9998]` — below the notification modal's `z-[9999]` but above
 * everything else (see work-page-fixes.md SECTION C).
 */

const ToastContainer = () => {
  const { toasts, dismissToast } = useToast();

  if (!toasts || toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9998] flex flex-col items-center gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            id={toast.id}
            type={toast.type}
            message={toast.message}
            duration={toast.duration}
            onDismiss={dismissToast}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
